import type { ColorInput } from 'tinycolor2';
import tinycolor from 'tinycolor2';

/**
 * @description In some cases instead of using this function, you can use the parameter `from` in rgb string
 * @example
 * ```ts
 * color: rgb(from <your-color> r g b / <alpha_value>)
 * ```
 * [MDN Reference](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_colors/Relative_colors)
 */
export function getColorWithAlpha(color: ColorInput, alpha: number): string {
  return tinycolor(color).setAlpha(alpha).toRgbString();
}
